import React from "react";
import { useHistory } from "react-router";

//block groups
import TableWithSearch from "../../../../../blockGroups/table/TableWithSearch/TableWithSearch.blockgroup";

// utils
import { cleanPurchaseOrderData } from "./PurchaseOrdersListWithSearch.collection.utils";
import { dateComparator } from "../../../../../shared/sorting/dates";
import { useTableSort } from "../../../../../shared/hooks/useTableSort";

const purchaseSearchFieldOptions = [
    { value: "number", title: "Number"},
    { value: "vendorName", title: "Vendor"},
    { value: "job", title: "Job"},
    { value: "customerName", title: "Customer"}
]

const purchaseOrdersTableColumnConfigs = [
    {
        name: "number",
        title: "Number",
        objectFieldsToDisplay: ["number"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    {
        name: "job",
        title: "Job",
        objectFieldsToDisplay: ["job"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    {
        name: "customerName",
        title: "Customer",
        objectFieldsToDisplay: ["customerName"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },    
    {
        name: "vendor",
        title: "Vendor",
        objectFieldsToDisplay: ["vendorName"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    {
        name: "totalAmount",
        title: " Total $",
        objectFieldsToDisplay: ["totalCents"],
        objectFieldsDelimeter: "",
        useNestedObject: false,
        sortable: false
    },
    {
        name: "numItems",
        title: "# of Items",
        objectFieldsToDisplay: ["numItems"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    {
        name: "status",
        title: "Status",
        objectFieldsToDisplay: ["status"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    { 
        name: "datetimeCreated", 
        title: "Created Date", 
        objectFieldsToDisplay: ["datetimeCreated"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: "date",
        sortComparator: dateComparator
    },
    
]

const PurchaseOrderListWithSearch =({data = {allEquipmentPurchaseOrders:[]}, loading, error, onAddClick, pageProps}) => {
    const history = useHistory()
    const handleRowClick = (rowData) => {
        history.push(`/inventory/purchase-orders/${rowData.id}`)
    }

    const sortModel = useTableSort(pageProps.location.search, { field: "datetimeCreated", sort: "desc"})
    const handleSortChange = (newSortModel) => {
        if(newSortModel.length > 0) {
            history.push(`/inventory/purchase-orders?sortField=${newSortModel[0].field}&sortDirection=${newSortModel[0].sort}`)
        } else {
            history.push(`/inventory/purchase-orders?sortField=${""}&sortDirection=${""}`)
        }
    }

    const addButtonConfig = {
        text: "New Purchase Order",
        onClick: onAddClick
    }

    let cleanedData = []
    if(data.allEquipmentPurchaseOrders) {
        cleanedData = [...cleanPurchaseOrderData(data.allEquipmentPurchaseOrders)]
    }

    return(<TableWithSearch
        rawData={cleanedData}
        loading={loading}
        error={error}
        searchFieldOptions={purchaseSearchFieldOptions}
        columnConfigs={purchaseOrdersTableColumnConfigs}
        addButtonConfig={addButtonConfig}
        onRowClick={handleRowClick}
        sortModel={sortModel}
        onSortModelChange={handleSortChange}
        pageProps={pageProps}
    />)
}
export default PurchaseOrderListWithSearch;